import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import styles from './styles';

const NumberInput = ({ classes, field, value, onChange, min = 0, max = 100, ...props }) => {
    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleChange = (e) => {
        const newValue = Math.max(min, Math.min(max, parseInt(e.target.value, 10) || min));
        setLocalValue(newValue);
        onChange(field, newValue);
    };

    const handleIncrement = () => {
        const newValue = Math.min(max, localValue + 1);
        setLocalValue(newValue);
        onChange(field, newValue);
    };

    const handleDecrement = () => {
        const newValue = Math.max(min, localValue - 1);
        setLocalValue(newValue);
        onChange(field, newValue);
    };

    return (
        <div className={classes.numberInputWrapper}>
            <input
                type="number"
                value={localValue}
                onChange={handleChange}
                min={min}
                max={max}
                className={classes.numberInput}
                {...props}
            />
            <div className={classes.arrows}>
                <button onClick={handleIncrement} className={classes.arrowButton}>
                    <ArrowDropUpIcon />
                </button>
                <button onClick={handleDecrement} className={classes.arrowButton}>
                    <ArrowDropDownIcon />
                </button>
            </div>
        </div>
    );
};

export default withStyles(styles)(NumberInput);
